import { c as _c } from "react/compiler-runtime";
import { BoxProps, Button, ButtonProps, Separator, Heading, SimpleGrid, StackProps, Text, VStack, List } from '@chakra-ui/react';
import { SignupRequestPreviewCard } from '@src/components/sco/Requests/SignupRequestBuilder/PreviewStep';
import { SignupRequestPreviewInvestorMatches } from '@src/components/sco/Requests/SignupRequestBuilder/SignupRequestPreviewInvestorMatches';
import { SignupRequestPreviewTasks } from '@src/components/sco/Requests/SignupRequestBuilder/SignupRequestPreviewTasks';
import { SignupRequestPreviewUserMatches } from '@src/components/sco/Requests/SignupRequestBuilder/SignupRequestPreviewUserMatches';
import { generateSignupRequestPreviewTitle } from '@src/components/sco/Requests/SignupRequestBuilder/helpers';
import { ChevronRightIcon } from '@src/components/sco/icons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { ScoSignupRequest } from '@src/graphql-types';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import React from 'react';
export const SignupRequestPriorityStep = props => {
  const $ = _c(46);
  const {
    currentUser
  } = useCurrentUser();
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let matchesType = "goal";
  if (props.groupRequestType?.key) {
    if (props.groupRequestType?.key === "funding") {
      matchesType = "investor";
    } else {
      if (props.groupRequestType?.key !== "goal") {
        matchesType = "user";
      }
    }
  }
  const t0 = props.borderRadius;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [1, 1, 2];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== getBreakpointValue) {
    t2 = getBreakpointValue([2, 4, 4, 4, 4]);
    $[1] = getBreakpointValue;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== getBreakpointValue) {
    t3 = getBreakpointValue([4, 6, 6, 8, 10]);
    $[3] = getBreakpointValue;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props.signupRequest) {
    t4 = generateSignupRequestPreviewTitle(props.signupRequest);
    $[5] = props.signupRequest;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = props.groupRequestType?.title;
  let t6;
  if ($[7] !== props.signupRequest.investorIndustryTagTitles) {
    t6 = props.signupRequest?.investorIndustryTagTitles || [];
    $[7] = props.signupRequest.investorIndustryTagTitles;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== props.signupRequest.skillTagTitles) {
    t7 = props.signupRequest?.skillTagTitles || [];
    $[9] = props.signupRequest.skillTagTitles;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== props.signupRequest.createdByIpLocation || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t8 = [t5, ...t6, ...t7, props.signupRequest.createdByIpLocation].filter(Boolean);
    $[11] = props.signupRequest.createdByIpLocation;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== props) {
    t9 = () => props.setShowStep("edit");
    $[16] = props;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t4 || $[19] !== t8 || $[20] !== t9) {
    t10 = <SignupRequestPreviewCard title={t4} tags={t8} onEditClick={t9} />;
    $[18] = t4;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== matchesType || $[23] !== props.signupRequest) {
    t11 = matchesType === "investor" && <SignupRequestPreviewInvestorMatches signupRequest={props.signupRequest} />;
    $[22] = matchesType;
    $[23] = props.signupRequest;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== matchesType || $[26] !== props.signupRequest) {
    t12 = matchesType === "user" && <SignupRequestPreviewUserMatches signupRequest={props.signupRequest} />;
    $[25] = matchesType;
    $[26] = props.signupRequest;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== matchesType || $[29] !== props.signupRequest) {
    t13 = false && process.env.NEXT_PUBLIC_DEPLOYMENT_ENV !== "production" && matchesType === "goal" && <SignupRequestPreviewTasks signupRequest={props.signupRequest} />;
    $[28] = matchesType;
    $[29] = props.signupRequest;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t10 || $[32] !== t11 || $[33] !== t12 || $[34] !== t13 || $[35] !== t2 || $[36] !== t3) {
    t14 = <VStack background="colorPalette.panel" gap={t2} justify="start" padding={t3} width="full">{t10}{t11}{t12}{t13}</VStack>;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
    $[35] = t2;
    $[36] = t3;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== currentUser?.isFounderGroupsMember || $[39] !== getBreakpointValue || $[40] !== props) {
    t15 = currentUser?.isFounderGroupsMember ? <VStack alignSelf="stretch" background="LightBlue50" gap={6} justify="center" padding={getBreakpointValue([4, 6, 6, 8, 10])} width="full"><Heading size="2xl" textAlign="center">Ready to get started?</Heading><Button size="lg" variant="cta" onClick={() => props.setShowStep("commit")}>Explore My Request Workspace<ChevronRightIcon /></Button></VStack> : <VStack alignSelf="stretch" background="LightBlue50" gap={6} justify="start" padding={getBreakpointValue([4, 6, 6, 8, 10])} width="full"><Heading size="2xl" textAlign="center">How important is this to you?</Heading><VStack gap={4} width="full"><SignupRequestCTACard cta="Activate My Request" label="Critical" title="I need this now" ctaButtonProps={{
          onClick: () => {
            props.setShowStep("payment");
          }
        }} listItems={[{
          text: <>Unlock access to everyone who matches your goal</>
        }, {
          text: "Make your goal visible to 250,000+ professionals"
        }, {
          text: "Directly contact exactly who you want"
        }]} parentStackProps={{
          background: "colorPalette.card"
        }} /><SignupRequestCTACard cta="Keep Exploring" label="Optional" title="I'm just browsing" ctaButtonProps={{
          variant: "outline",
          onClick: () => {
            props.setShowStep("commit");
          }
        }} listItems={[{
          text: "Continue refining your goal"
        }, {
          text: "Access our Community and Education"
        }, {
          text: "View new potential matches"
        }]} parentStackProps={{
          background: "colorPalette.bg/50",
          boxShadow: "none"
        }} /></VStack></VStack>;
    $[38] = currentUser?.isFounderGroupsMember;
    $[39] = getBreakpointValue;
    $[40] = props;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== props.borderRadius || $[43] !== t14 || $[44] !== t15) {
    t16 = <SimpleGrid borderRadius={t0} columns={t1} gap={0} overflow="hidden">{t14}{t15}</SimpleGrid>;
    $[42] = props.borderRadius;
    $[43] = t14;
    $[44] = t15;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  return t16;
};
type SignupRequestCTACardListItemProps = {
  text: string | React.ReactNode;
};
type SignupRequestCTACardProps = {
  title: string;
  label: string;
  cta: string;
  listItems: SignupRequestCTACardListItemProps[];
  parentStackProps?: StackProps;
  ctaButtonProps?: ButtonProps;
};
export const SignupRequestCTACard = props => {
  const $ = _c(27);
  const {
    getBreakpointValue,
    isMobile
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([4]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== getBreakpointValue) {
    t1 = getBreakpointValue([4, 4, 8]);
    $[2] = getBreakpointValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = props.parentStackProps;
  const t3 = isMobile ? "0.875rem" : "1rem";
  let t4;
  if ($[4] !== props.label || $[5] !== t3) {
    t4 = <Text color="mocha" fontSize={t3} textStyle="badgeSm">{props.label}</Text>;
    $[4] = props.label;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = isMobile ? "xl" : "2xl";
  let t6;
  if ($[7] !== props.title || $[8] !== t5) {
    t6 = <Heading size={t5} textAlign="center">{props.title}</Heading>;
    $[7] = props.title;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = isMobile ? "md" : "lg";
  let t8;
  if ($[10] !== props.cta || $[11] !== props.ctaButtonProps || $[12] !== t7) {
    t8 = <Button size={t7} variant="cta" width="full" {...props.ctaButtonProps}>{props.cta}</Button>;
    $[10] = props.cta;
    $[11] = props.ctaButtonProps;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Separator />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== props.listItems) {
    t10 = props.listItems.map(_temp);
    $[15] = props.listItems;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = t10 as React.ReactNode;
  let t12;
  if ($[17] !== t11) {
    t12 = <List.Root as="ul">{t11}</List.Root>;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== props.parentStackProps || $[20] !== t0 || $[21] !== t1 || $[22] !== t12 || $[23] !== t4 || $[24] !== t6 || $[25] !== t8) {
    t13 = <VStack align="center" background="backgroundTertiary" borderRadius="2xl" boxShadow="lg" direction="column" gap={t0} justify="center" padding={t1} width="full" {...t2}>{t4}{t6}{t8}{t9}{t12}</VStack>;
    $[19] = props.parentStackProps;
    $[20] = t0;
    $[21] = t1;
    $[22] = t12;
    $[23] = t4;
    $[24] = t6;
    $[25] = t8;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};
const SignupRequestCTACardListItem = props => {
  const $ = _c(3);
  const {
    isMobile
  } = useBreakpointContext();
  const t0 = isMobile ? "labelSm" : "labelSm";
  let t1;
  if ($[0] !== props.text || $[1] !== t0) {
    t1 = <List.Item><Text textStyle={t0}>{props.text}</Text></List.Item>;
    $[0] = props.text;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
function _temp(item) {
  return <SignupRequestCTACardListItem key={item.text as string} text={item.text} />;
}